import { useState } from 'react';
import Main from '../../../component/Main.jsx';
import HospitalVisitSelect from '../06_incurr_trms/HospitalVisitSelect.jsx';
import SearchBtn from '../../../component/common/button/SearchBtn.jsx';
import DataGridClickedPopup from '../../../component/common/popup/DataGridClickedPopup.jsx';

const TrmsFirstVisit = () => {

    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date(new Date().getTime() - 1000 * 60 * 60 * 24 * 30 + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchEmog: '',
        searchIdno: '',
        searchGrdc: '',
        searchLoca: '',
        searchCheck1: '',
        searchCheck2: '1',
        searchGubunS: '1',
    });

    const [desc, setDesc] = useState('');

    const searchParamsAdditional = {
        userAuth: localStorage.getItem("userAuth"),
        userEmcd: localStorage.getItem("useremcd"),
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    const dataHead = [['기관명', '전체', '외상팀 진료개시건', '외상팀 진료개시율', '외상팀 진료개시 소요시간', '외상팀 진료개시 소요시간', '외상팀 진료개시 소요시간', '외상팀 진료개시 소요시간', '외상팀 진료개시 소요시간'], ['기관명', '전체', '외상팀 진료개시건', '외상팀 진료개시율', '평균값', '중앙값', '최소값', '최대값', '산출 제외건']]; //component화 
    const dataColumn = ['TRMSEMNM', 'TOT_CNT', 'INITIATION_CNT', 'INITIATION_RATE', 'AVG_VAL', 'MEDIAN_VAL', 'MIN_VAL', 'MAX_VAL', 'EXCLUDE_CASE'];
    const apiCall = '/trmsapi/trtinfo/bdtongtrms_stat_to_first_visit_use_time_search.do';
    const apiCntCall = '';
    const excelFileName = `${desc || '전체'}_외상팀 진료개시 소요시간`;
    const excelHead = ['기관명', '전체', '외상팀 진료개시건', '외상팀 진료개시율', '평균값', '중앙값', '최소값', '최대값', '산출 제외건'];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead,
        colWidth: ['20%'],
        wrapTF: true,
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    const popupPropsInfo = {
        checked: ["MAX", "MIN", "EXCLUDE"],
        localStorageName: "firstVisitData",
        popupAddress: "/nedis/trmsInfo/trms_firstVisit_popup.do",
        flag: 'trms'
    }

    return (
        <Main>
            <div className="com-search">
                <table>
                    <colgroup>
                        <col width="10%" />
                        <col width="24%" />
                        <col width="10%" />
                        <col width="18%" />
                        <col width="10%" />
                        <col width="18%" />
                    </colgroup>
                    <tbody>
                        <tr>
                            <HospitalVisitSelect
                                searchParams={searchParams}
                                handleInputChange={handleInputChange}
                                setDesc={setDesc}
                            />
                        </tr>
                        <tr>
                            <th>환자분류</th>
                            <td>
                                <select id="searchCheck1"
                                    name="searchCheck1"
                                    value={searchParams.searchCheck1}
                                    onChange={handleInputChange}
                                >
                                    <option value="">전체</option>
                                    <option value="2">응급센터</option>
                                    <option value="1">외상센터</option>
                                </select>
                            </td>
                            <th>중증도</th>
                            <td>
                                <select id="searchCheck2"
                                    name="searchCheck2"
                                    value={searchParams.searchCheck2}
                                    onChange={handleInputChange}
                                >
                                    <option value="1">전체</option>
                                    <option value="2">중증외상</option>
                                </select>
                            </td>
                            <th>외상팀 구분</th>
                            <td>
                                <select id="searchGubunS"
                                    name="searchGubunS"
                                    value={searchParams.searchGubunS}
                                    onChange={handleInputChange}
                                >
                                    <option value="1">활성화팀</option>
                                    <option value="2">on-call</option>
                                </select>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <SearchBtn
                propsInfo={propsInfo}
                state={state}
                setState={setState}
                searchParams={searchParams}
                searchParamsAdditional={searchParamsAdditional}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
            />
            <DataGridClickedPopup
                propsInfo={propsInfo}
                state={state}
                pageInfo={pageInfo}
                setPageInfo={setPageInfo}
                searchParams={searchParams}
                popupPropsInfo={popupPropsInfo}
            />
            <p> * 외상등록체계 전송 대상자 중 ‘외상환자 제외’ 및 ‘연동 후 제외’, ‘외상 삭제’ 제외 </p>
            <p> * 외상팀 진료개시율: 전체 환자 중 [활성화팀/on-call 도착일시]가 입력된 환자의 비율 </p>
            <p> * 외상팀 진료개시 소요시간: 내원 후 최초 외상팀 최초 도착일시까지의 소요시간을 말하며, 평균값 및 중앙값의 경우 소요시간이 0분 미만인 건은 0분으로 대체하여 산출 </p>
            <p> * 밑줄 표시된 값의 경우 더블클릭 시 해당 환자 건 조회 가능 </p>
            <p> * on-call의 경우 2020년 1월부터 전송하는 항목이므로, 2020년 이전과 이후 동시 검색 시 주의 </p>
        </Main>
    )
}

export default TrmsFirstVisit;